<template>
  <el-form label-position="top" ref="form" :model="data">
    <el-row>
      <h2>连接信息</h2>
      <el-input v-model="data.cs_pt_class" readonly></el-input>
      <el-col :span="12 ">
        <el-form-item label="连接协议标识">
          <el-input v-model="data.cs_pt_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="连接协议名称">
          <el-input v-model="data.cs_pt_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="连接标识">
          <el-input v-model="data.cs_cn_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="连接名称">
          <el-input v-model="data.cs_cn_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="连接池容量">
          <el-input v-model="data.cs_cn_poolsize" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="终端信息">
          <el-input v-model="data.cs_cn_conf" readonly></el-input>
        </el-form-item>
      </el-col>
      <h2>终端信息</h2>
      <el-input v-model="data.cs_class" readonly></el-input>
      <el-col :span="12 ">
        <el-form-item label="终端标识">
          <el-input v-model="data.cs_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="终端名称">
          <el-input v-model="data.cs_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="终端状态">
          <el-input v-model="data.cs_status" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="终端字符集">
          <el-input v-model="data.cs_charset" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="连接池容量">
          <el-input v-model="data.cs_cnnum" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="终端配置">
          <el-input v-model="data.cs_conf" readonly></el-input>
        </el-form-item>
      </el-col>

      <h2>持久化信息</h2>
      <el-input v-model="data.cm_class" readonly></el-input>
      <el-col :span="12 ">
        <el-form-item label="组件标识">
          <el-input v-model="data.cm_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="组件名称">
          <el-input v-model="data.cm_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="持久化组件配置">
          <el-input v-model="data.cm_conf" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="  ">
          <el-input readonly></el-input>
        </el-form-item>
      </el-col>

      <br />
      <h2>内容路由信息</h2>
      <el-input v-model="data.cf_class" readonly></el-input>
      <el-col :span="12 ">
        <el-form-item label="路由标识">
          <el-input v-model="data.cf_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="路由名称">
          <el-input v-model="data.cf_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="路由配置">
          <el-input v-model="data.cf_conf" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12 ">
        <el-form-item label="  ">
          <el-input readonly></el-input>
        </el-form-item>
      </el-col>

      <h2>回执路由信息</h2>
      <el-input v-model="data.cr_class" readonly></el-input>
      <el-col :span="12">
        <el-form-item label="路由标识">
          <el-input v-model="data.cr_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="路由名称">
          <el-input v-model="data.cr_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="路由配置">
          <el-input v-model="data.cr_conf" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="  ">
          <el-input readonly></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-card class="margin-top-2">
      <template slot="header">
        <span>数据查询列表</span>
      </template>
      <el-table ref="dataTable" :auto-load="false" :data="table.data" highlight-current-row stripe border height="250">

        <el-table-column prop="cs_defn" label="消费者标识" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cs_name" label="消费者名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pd_defn" label="回执生产者标识" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pd_name" label="回执生产者名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="rc_defn" label="回执责任链标识" show-overflow-tooltip></el-table-column>
        <el-table-column prop="rc_name" label="回执责任链名称" show-overflow-tooltip></el-table-column>
      </el-table>
    </el-card>
  </el-form>
</template>

<script>
export default {
  props: {
    datcs: {}
  },
  data() {
    return {
      data: {},
      table: {
        data: []
      },
      options: []
    };
  },
  // 当前组件显示到页面之后立即执行，（挂载到页面）
  mounted() {
    this.loadInfo();
  },
  watch: {
    dat: function() {
      this.loadInfo();
    }
  },
  methods: {
    loadInfo() {
      this.data = this.datcs;
      this.table.data = this.datcs.receipts;
      /*   this.data.item_name = this.datpd.itemname;
      this.data.item_conf = this.datpd.itemconf;
      this.data.item_uuid = this.datpd.itemuuid;
      this.data.opcomment = this.datpd.opcomment; */
    }
  }
};
</script>

<style>
</style>
